import { render, staticRenderFns } from "./JxcSetting.vue?vue&type=template&id=1b4746fa&scoped=true"
import script from "./JxcSetting.vue?vue&type=script&lang=js"
export * from "./JxcSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4746fa",
  null
  
)

export default component.exports